import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { useInstagramUserHashtagsQuery } from '@anytag/graphql';
import { useInstagramHashtagsAnalyticsFilter } from '@anytag/shared-organisms';
import { Template } from './template';

export const InstagramHashtagsAnalytics = () => {
  useUpdateDocumentTitle({
    title: 'appHeader.Instagram Hashtag Analytics',
    appHeader: 'appHeader.Instagram Hashtag Analytics'
  });
  const { filter, setFilter, countryId } = useInstagramHashtagsAnalyticsFilter();
  const { data, loading, called } = useInstagramUserHashtagsQuery({
    variables: { countryId },
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ instagramUserHashtags }) => {
      const isValidHashtag =
        instagramUserHashtags?.hashtags?.findIndex((hashtag) => hashtag.hashtagId === filter.tagId) !== -1;

      if (!filter.tagId || !isValidHashtag) {
        setFilter({ tagId: instagramUserHashtags?.hashtags?.at(0)?.hashtagId || '' }, { replace: true });
      }
    }
  });

  return (
    <RenderDataWithFallback loading={loading && !called} hasNoData={!filter.date}>
      <Template hashtags={data?.instagramUserHashtags.hashtags || []} />
    </RenderDataWithFallback>
  );
};
